var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var TeamNode_1;
import { Field, ObjectType, registerEnumType } from "type-graphql";
import { Node } from "../relay.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { TimestampedResource } from "./Resource.js";
export const TeamType = {
    Spirit: "Spirit",
    Morale: "Morale",
    Mini: "Mini",
};
export const TeamTypeValues = Object.values(TeamType);
// Registering the TeamType enum with TypeGraphQL
registerEnumType(TeamType, {
    name: "TeamType",
    description: "Types of teams",
});
export const TeamLegacyStatus = {
    NewTeam: "NewTeam",
    ReturningTeam: "ReturningTeam",
    DemoTeam: "DemoTeam",
};
export const TeamLegacyStatusValues = Object.values(TeamLegacyStatus);
// Registering the TeamLegacyStatus enum with TypeGraphQL
registerEnumType(TeamLegacyStatus, {
    name: "TeamLegacyStatus",
    description: "New Team vs Returning Team",
});
let TeamNode = TeamNode_1 = class TeamNode extends TimestampedResource {
    id;
    name;
    type;
    legacyStatus;
    text() {
        return this.name;
    }
    getUniqueId() {
        return this.id.id;
    }
    static init(init) {
        return TeamNode_1.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], TeamNode.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], TeamNode.prototype, "name", void 0);
__decorate([
    Field(() => TeamType, { nullable: false }),
    __metadata("design:type", String)
], TeamNode.prototype, "type", void 0);
__decorate([
    Field(() => TeamLegacyStatus, { nullable: false }),
    __metadata("design:type", String)
], TeamNode.prototype, "legacyStatus", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], TeamNode.prototype, "text", null);
TeamNode = TeamNode_1 = __decorate([
    ObjectType({
        implements: [Node],
    })
], TeamNode);
export { TeamNode };
//# sourceMappingURL=Team.js.map